import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './ChecklistSection.css';

const checks = [
  'Gestão de Condicionais • Bag Delivery',
  'APP Vendedor',
  'APP Gestor',
  'Catálogo Digital',
  'PDV • Frente de Caixa',
  'Inteligência de Compras',
  'Gestão de Estoques e Transferências',
  'Financeiro Completo',
  'Controle de crediário próprio',
  'IA para Vendas',
  'Relatórios e Dashboards',
  'Integração E-commerce',
];

const ChecklistSection = () => {
  return (
    <section className="checklist-section">
      <div className="container">
        <div className="checklist-section__header">
          <h2 className="checklist-section__title">
            Somos{' '}
            <span className="checklist-section__title-highlight">especialistas</span>{' '}
            em gestão para varejo de moda
          </h2>
        </div>

        <div className="checklist-section__grid">
          {checks.map((item, index) => (
            <div key={index} className="checklist-section__item">
              <span className="checklist-section__icon">
                <FontAwesomeIcon icon={faCheck} />
              </span>
              <span className="checklist-section__label">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChecklistSection;
